import { Reveal } from "./Reveal";
import { Building2, Rocket, Briefcase, GraduationCap, User, Sparkles } from "lucide-react";

const AUDIENCES = [
  { icon: Building2, title: "Businesses", desc: "Find suppliers, space, partners and customers beyond your existing circle." },
  { icon: Rocket, title: "Entrepreneurs", desc: "Co-founders, capital, mentors and the missing piece of your venture." },
  { icon: Briefcase, title: "Professionals", desc: "Put your expertise in front of the people actively searching for it." },
  { icon: GraduationCap, title: "Students & Young People", desc: "First opportunities, guidance and a network that usually takes years to build." },
  { icon: User, title: "Individuals", desc: "Whatever you need — or whoever needs what you have — start here." },
  { icon: Sparkles, title: "Anyone With Value to Offer", desc: "If you have a skill, an asset or an idea, there is someone on the other side of the X." },
];

export const AudienceGrid = () => (
  <section id="who" data-testid="audience-section" className="relative py-28 lg:py-36 border-t border-white/5">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <Reveal>
        <span className="font-mono-accent text-xs tracking-[0.3em] text-[#00F0FF]" data-testid="audience-eyebrow">
          /// THE NETWORK
        </span>
        <h2 className="mt-6 font-display font-extrabold uppercase text-3xl sm:text-4xl lg:text-5xl leading-[1.02] text-slate-100 max-w-3xl" data-testid="audience-title">
          Who is FINDXCHANGE <span className="text-[#00F0FF]">for</span>?
        </h2>
      </Reveal>

      <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
        {AUDIENCES.map((a, i) => (
          <Reveal key={a.title} delay={i * 0.07} className="h-full">
            <div className="card-frame group h-full p-9 lg:p-10" data-testid={`audience-card-${i}`}>
              <div className="flex items-center justify-between">
                <a.icon size={22} className="text-[#00F0FF] transition-transform duration-500 group-hover:-translate-y-1 group-hover:scale-110" />
                <span className="font-mono-accent text-[10px] tracking-[0.3em] text-slate-700 group-hover:text-slate-500 transition-colors">
                  {String(i + 1).padStart(2, "0")}
                </span>
              </div>
              <h3 className="mt-7 font-display font-bold uppercase text-xl text-slate-100 tracking-wide">{a.title}</h3>
              <p className="mt-3 text-sm text-slate-500 leading-relaxed">{a.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
